import { actionCreatorFactory } from "typescript-fsa";

const factory = actionCreatorFactory("MODULF");

export const importFileActionCreator = factory<ImportFileAction>("READ_XML");

export interface ImportFileAction {
	readonly mainActivityId: string;
	readonly modalActivityId: string;
	readonly importFile: File;
}
